// extracted by mini-css-extract-plugin
export default {"header":"Arp_header__VbJai","image-wrap":"Arp_image-wrap__2IT2h","image":"Arp_image__iz17E"};